import React from 'react';
import { useGameStore } from '../../store/GameStoreContext.ts';
import { UIGameReplayControls } from './UIGameReplayControls.tsx';
export const UIGameReplayControlsContainer = ({ useMinimalControls, disableTooltips })=>{
    const userStates = useGameStore((state)=>state.gameUserStates.userStates);
    const actionIndex = useGameStore((state)=>state.gameReplay.actionIndex);
    const replayControls = useGameStore((state)=>state.gameReplay.replayControls);
    if (replayControls == undefined) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(UIGameReplayControls, {
        useMinimalReplayControls: useMinimalControls,
        currentActionIndex: actionIndex,
        playerUserStates: userStates,
        disableTooltips: disableTooltips,
        ...replayControls
    });
};
